import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

var _effectorFileName = "/builds/gmini/front-common/src/components/BaseConditions/BaseConditions.tsx",
    _mStyled;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/es.array.some.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { Popper, TextField, autocompleteClasses, paperClasses } from '@mui/material';
import { styled as mStyled } from '@mui/styles';
import { InputProgress, VirtualizedAutocomplete } from '@gmini/ui-kit';
import { CrossCircle } from '@gmini/ui-kit/lib/icons';
import { isNotEmpty, useDebounceState } from '@gmini/utils';
import { createEvent, restore } from 'effector';
import { useStore } from 'effector-react';
import { AutocompleteOption } from "./AutocompleteOption";
import { PropertyTag } from "./PropertyTag";
import { HeaderBaseConditions, SettingNames } from "./HeaderBaseConditions";
import { AutocompleteCloseIconWrapper, DisabledWrapper, InputWrapper } from "./BaseConditions.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var emptyArray = [];
var settingList = [{
  renderName: 'Показать группу',
  name: SettingNames.showGroup
}];
var debounceDelay = 400;
var setSelectedSettings = createEvent({
  name: "setSelectedSettings",
  sid: "mk4tjm"
});
var selectedSettings$ = restore(setSelectedSettings, [], {
  name: "selectedSettings$",
  sid: "-nu8yur"
});
export var BaseConditions = /*#__PURE__*/React.memo(function (_ref) {
  var selectedPropertiesIds = _ref.selectedPropertiesIds,
      availableProperties = _ref.availableProperties,
      propertiesById = _ref.propertiesById,
      listPending = _ref.listPending,
      pending = _ref.selectPending,
      selectProperties = _ref.selectProperties,
      title = _ref.title,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onOpenList = _ref.onOpenList,
      widthFormulaResizableCol = _ref.widthFormulaResizableCol,
      readonly = _ref.readonly;
  var selectedSettings = useStore(selectedSettings$, {
    loc: {
      file: _effectorFileName,
      line: 78,
      column: 29
    },
    name: "BaseConditions",
    sid: "BaseConditions /src/components/BaseConditions/BaseConditions.tsx [78, 29]"
  });

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focusedAutocomplete = _React$useState2[0],
      setFocusedAutocomplete = _React$useState2[1];

  var _React$useState3 = React.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      valueAutocomplete = _React$useState4[0],
      setValueAutocomplete = _React$useState4[1];

  var autocompleteRef = React.useRef(null);
  var selectedProperties = React.useMemo(function () {
    return selectedPropertiesIds.map(function (id) {
      return propertiesById[id];
    }).filter(isNotEmpty);
  }, [propertiesById, selectedPropertiesIds]);
  var onChangeSelectedSettings = React.useCallback(function (settingName) {
    setSelectedSettings(selectedSettings.includes(settingName) ? selectedSettings.filter(function (name) {
      return name !== settingName;
    }) : [].concat(_toConsumableArray(selectedSettings), [settingName]));
  }, [selectedSettings]);
  var propertyList = availableProperties;

  var _useDebounceState = useDebounceState({
    initialState: selectedProperties,
    delay: debounceDelay,
    onChange: function onChange(columns) {
      selectProperties(columns.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      }));
      setTimeout(function () {
        var _autocompleteRef$curr;

        // хак для того чтобы накинуть фокус после сохранения условия
        autocompleteRef === null || autocompleteRef === void 0 ? void 0 : (_autocompleteRef$curr = autocompleteRef.current) === null || _autocompleteRef$curr === void 0 ? void 0 : _autocompleteRef$curr.focus();
      }, debounceDelay + 300);
    }
  }),
      debouncePending = _useDebounceState.pending,
      state = _useDebounceState.state,
      submit = _useDebounceState.submit;

  var getOptionLabel = React.useCallback(function (option) {
    return option.name;
  }, []);
  var renderInput = React.useCallback(function (params) {
    return /*#__PURE__*/_jsx(BaseConditionsAutocompleteTextField, _objectSpread(_objectSpread({}, params), {}, {
      onChange: function onChange(event) {
        if (!pending && !debouncePending) {
          setValueAutocomplete(event.target.value);
        }
      },
      value: valueAutocomplete,
      placeholder: state.length > 0 ? '' : 'Введите название...',
      variant: "outlined",
      inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
        'data-test-id': 'enterColumnTitle'
      }),
      inputRef: autocompleteRef,
      focusedInput: focusedAutocomplete,
      existSelectedProperties: selectedProperties.length > 0 || valueAutocomplete.length > 0
    }));
  }, [debouncePending, focusedAutocomplete, selectedProperties, pending, state.length, valueAutocomplete]);
  var renderOption = React.useCallback(function (_, option) {
    return /*#__PURE__*/_jsx(AutocompleteOption, {
      name: option.name,
      groupName: option.groupName
    });
  }, []);
  var onChange = React.useCallback(function (_, columns) {
    if (!pending && !debouncePending && !disabled) {
      submit(columns);
      setValueAutocomplete('');
    }
  }, [debouncePending, disabled, pending, submit]);
  var renderTags = React.useCallback(function (values, getTagProps) {
    var valuesTyped = values;

    var valueIds = _toConsumableArray(new Set(valuesTyped.map(function (value) {
      return value.id;
    })));

    var valueMap = new Map(valuesTyped.map(function (value) {
      return [value.id, value];
    }));
    return valueIds.map(function (valueId, index) {
      var value = valueMap.get(valueId);
      return /*#__PURE__*/_jsx(PropertyTag, {
        name: value.name,
        groupName: selectedSettings.includes(SettingNames.showGroup) ? value.groupName : '',
        isNotInList: !(propertyList !== null && propertyList !== void 0 && propertyList.some(function (p) {
          return p.id === value.id;
        })),
        getTagProps: getTagProps,
        index: index,
        readonly: readonly
      }, value.id);
    });
  }, [propertyList, readonly, selectedSettings]);
  var onFocusAutocomplete = React.useCallback(function () {
    setFocusedAutocomplete(true);
  }, []);
  var onBlurAutocomplete = React.useCallback(function () {
    setFocusedAutocomplete(false);
    setValueAutocomplete('');
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(HeaderBaseConditions, {
      title: title,
      onChangeSelectedSettings: onChangeSelectedSettings,
      selectedSettings: selectedSettings,
      settingList: settingList,
      propertyList: propertyList,
      onSavePropertyList: submit,
      selectedPropertyList: state || emptyArray,
      loading: pending || debouncePending,
      disabled: disabled,
      onOpenList: onOpenList,
      listPending: listPending,
      widthFormulaResizableCol: widthFormulaResizableCol,
      readonly: readonly
    }), /*#__PURE__*/_jsxs(InputWrapper, {
      children: [/*#__PURE__*/_jsx(InputProgress, {
        show: pending || listPending || debouncePending
      }), disabled && /*#__PURE__*/_jsx(DisabledWrapper, {}), /*#__PURE__*/_jsx(BaseConditionsAutocomplete, {
        noOptionsText: listPending ? 'Идёт загрузка' : 'Нет доступных свойств',
        multiple: true,
        options: propertyList || emptyArray,
        getOptionLabel: getOptionLabel,
        renderInput: renderInput,
        renderOption: renderOption,
        renderTags: renderTags,
        value: state || emptyArray,
        inputValue: valueAutocomplete,
        onChange: onChange,
        onFocus: onFocusAutocomplete,
        onBlur: onBlurAutocomplete,
        disabled: disabled || pending || debouncePending || readonly,
        popupIcon: null,
        PopperComponent: BaseConditionsAutocompletePopper,
        componentsProps: {
          popper: {
            open: focusedAutocomplete && valueAutocomplete.length > 0
          }
        },
        clearIcon: /*#__PURE__*/_jsx(AutocompleteCloseIconWrapper, {
          "data-test-id": "clearSimpleField",
          children: /*#__PURE__*/_jsx(CrossCircle, {})
        }),
        onOpen: onOpenList,
        size: "small",
        focusedInput: focusedAutocomplete,
        readonly: readonly
      })]
    })]
  });
});
var BaseConditionsAutocomplete = mStyled(VirtualizedAutocomplete)(function (_ref3) {
  var focusedInput = _ref3.focusedInput,
      readonly = _ref3.readonly;
  return {
    '& .MuiAutocomplete-listbox': {
      maxHeight: '70vh'
    },
    '& .MuiAutocomplete-root': {
      '& .MuiAutocomplete-input': {
        color: '#353B60'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
        borderRadius: '4px',
        boxShadow: focusedInput ? '0px 5px 10px rgba(53, 60, 96, 0.1)' : 'none',
        transition: 'background-color .2s ease-out, border-color .2s ease-out, box-shadow .2s ease-out'
      }
    },
    '& .MuiInputBase-root': {
      cursor: 'default'
    },
    '& .MuiAutocomplete-input': {
      color: '#353B60'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderRadius: '4px',
      boxShadow: focusedInput ? '0px 5px 10px rgba(53, 60, 96, 0.1)' : 'none',
      transition: 'background-color .2s ease-out, border-color .2s ease-out, box-shadow .2s ease-out'
    },
    '& .MuiAutocomplete-clearIndicator': {
      display: 'none'
    }
  };
});
var BaseConditionsAutocompleteTextField = mStyled(TextField)(function (_ref4) {
  var existSelectedProperties = _ref4.existSelectedProperties,
      focusedInput = _ref4.focusedInput;
  return {
    '& .MuiOutlinedInput-root': {
      boxShadow: 'none',
      minHeight: '40px',
      gap: '8px ',
      padding: '6px 30px 6px 12px !important',
      background: focusedInput ? 'inherit' : '#F4F4F8',
      border: focusedInput ? '1px solid #4C5ECF' : '1px solid transparent',
      transition: 'border-color ease-out .2s',
      '& .MuiAutocomplete-tag': {
        padding: 0,
        margin: 0
      },
      '&:hover': {
        border: focusedInput ? '1px solid #4C5ECF' : '1px solid #C5C6D1'
      },
      '& .MuiIconButton-label': {
        visibility: existSelectedProperties ? 'visible' : 'hidden'
      },
      '& .MuiAutocomplete-clearIndicator': {
        display: 'flex',
        alignItems: 'center',
        '& path': {
          opacity: 0.25
        },
        '&:hover': {
          background: 'none',
          '& path:first-child': {
            opacity: 1,
            fill: '#353b60'
          }
        },
        '&:active, &:focus': {
          '& path:first-child': {
            opacity: 1,
            fill: '#00003d'
          }
        }
      },
      '& .MuiAutocomplete-endAdornment': {
        top: '5.5px'
      },
      '& input': {
        fontSize: '14px',
        fontWeight: 500,
        color: 'rgba(0, 0, 0, 0.87)',
        paddingLeft: '2px !important'
      },
      '& input::placeholder': {
        fontWeight: 500,
        fontSize: '13px',
        color: 'rgba(0, 3, 53, 1)'
      }
    }
  };
});
var BaseConditionsAutocompletePopper = mStyled(Popper)((_mStyled = {
  padding: 0
}, _defineProperty(_mStyled, "& .".concat(paperClasses.root), {
  boxShadow: '0px 5px 10px rgb(53 60 96 / 15%) !important',
  border: '1px solid #EDEFF3 !important',
  borderRadius: '4px',
  margin: '2px -3px 0 0',
  fontSize: '14px',
  fontWeight: 500,
  color: '#353B60'
}), _defineProperty(_mStyled, "& .".concat(autocompleteClasses.noOptions), {
  color: '#353B60',
  padding: '10px 8px 10px 12px',
  cursor: 'default',
  fontWeight: 500,
  fontSize: '14px'
}), _mStyled));